import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { Image } from '@outdoor-voices/ui';
import css from './Help.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Help = function Help(_ref) {
  var items = _ref.items,
      isMobile = _ref.isMobile;
  return /*#__PURE__*/_jsx("div", {
    className: css.root,
    children: items.map(function (_ref2) {
      var id = _ref2.id,
          image = _ref2.image,
          imageMobile = _ref2.imageMobile,
          copy = _ref2.copy,
          title = _ref2.title,
          url = _ref2.url;
      var itemImage = isMobile ? imageMobile : image;
      return /*#__PURE__*/_jsxs("a", {
        className: css.item,
        href: url,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.image,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, itemImage), {}, {
            sizes: [320, 600, 900, 1200],
            wrap: false
          }))
        }), /*#__PURE__*/_jsx("h2", {
          className: css.title,
          children: title
        }), /*#__PURE__*/_jsx("p", {
          className: css.copy,
          children: copy
        })]
      }, id);
    })
  });
};

Help.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isMobile: PropTypes.bool.isRequired
};
export default Help;